// @ts-nocheck
/* ============================================================
   Fence Works — Building Codes data (IRC/IBC reference)
   Encoded from the code detail modals.
   ============================================================ */
window.VFP_CODES = [
  {
    id: "wood", name: "Wood Fences", sub: "Privacy, Board-on-Board, Horizontal — IRC R301.1, R312",
    glyph: "wood", badges: ["IRC"], color: "#b87d4b",
    mini: [["Height", "6 ft"], ["Post", "4×4"], ["Panel", "8 ft O.C."], ["Embed", "⅓ length"]],
    sections: [
      { title: "Height & Zoning", tag: "LOCAL ZONING", rows: [
        ["Residential Max (no permit)", "6' in most jurisdictions"],
        ["Front Yard Max", "3–4' (varies by city/county)"],
        ["Side/Rear Yard Max", "6' standard, 8' with permit"],
        ["Height Measurement", "From finished grade on higher side"],
        ["Corner Lot Sight Triangle", "3' max within 25' of intersection"],
      ]},
      { title: "Structural Requirements", tag: "IRC R301.1", rows: [
        ["Post Embedment", "Min ⅓ of total post length"],
        ["Post Size (≤6')", "4×4 min (3.5\"×3.5\" actual)"],
        ["Post Size (>6')", "6×6 recommended"],
        ["Post Spacing", "6–8' O.C. (8' max for 6' fence)"],
        ["Footing Diameter", "3× post width / 10–12\""],
        ["Footing Depth", "Below frost line per Table R301.2 (12\" min where no frost)"],
        ["Concrete", "1.5–2 bags (50 lb) per post"],
      ]},
      { title: "Material Standards", tag: "AWPA", rows: [
        ["Ground Contact", "UC4A min treated lumber (AWPA U1)"],
        ["Above Ground", "UC3B min or naturally durable (cedar/redwood)"],
        ["Fasteners", "Hot-dipped galvanized, stainless, or polymer-coated"],
        ["Hardware", "Corrosion-resistant (Simpson Strong-Tie or equiv.)"],
        ["Rails", "Min 2×4 for spans ≤8'; 2×6 for wind exposure"],
      ]},
      { title: "Setback & Property Lines", tag: "LOCAL", rows: [
        ["Typical Setback", "2–6\" inside property line"],
        ["Finished Side", "Faces neighbor (many jurisdictions)"],
        ["Easement Zones", "No structures — check plat/survey"],
        ["HOA Restrictions", "May further limit height, style, color"],
      ]},
    ],
    note: "Key IRC Reference: Chapter 3 covers structural loads. Most fence-specific requirements are set locally — always verify with the AHJ (Authority Having Jurisdiction).",
  },
  {
    id: "vinyl", name: "Vinyl Fences", sub: "Privacy, Semi-Privacy, Picket — ASTM F964, F1999",
    glyph: "vinyl", badges: ["IRC"], color: "#e9edf2",
    mini: [["Height", "6 ft"], ["Post", "5×5"], ["Reinforce", "Steel insert"], ["Embed", "30\" typ."]],
    sections: [
      { title: "Height & Zoning", tag: "IRC R301", rows: [
        ["Residential Max (no permit)", "6' in most jurisdictions"],
        ["Front Yard", "3–4' (varies)"],
        ["Wind Exposure C/D", "May require engineering for >4'"],
        ["Height Measurement", "From finished grade, higher side"],
      ]},
      { title: "Structural Requirements", tag: "ASTM F964", rows: [
        ["Post Size", "5×5 min vinyl (4×4 steel insert)"],
        ["Steel Reinforcement", "Required for ≥5' in wind zones"],
        ["Post Spacing", "6–8' O.C. per manufacturer"],
        ["Footing Depth", "Below frost line per Table R301.2 (12\" min where no frost)"],
        ["Footing Diameter", "10–12\" typical"],
        ["Concrete", "2–3 bags per post (reinforced)"],
      ]},
      { title: "Material Standards", tag: "ASTM", rows: [
        ["Vinyl Compound", "ASTM F964 (rigid PVC fence)"],
        ["Impact Resistance", "ASTM D256 (Izod impact test)"],
        ["UV Stability", "ASTM D4329 (1000+ hrs exposure)"],
        ["Flammability", "ASTM D635 (self-extinguishing)"],
        ["Color Stability", "ASTM D2244 (ΔE<3 typical — VSI convention)"],
      ]},
      { title: "Wind Load Compliance", tag: "IRC R301.2", rows: [
        ["Basic Wind Speed", "Per IRC Figure R301.2(5A)"],
        ["Exposure B (suburban)", "Standard post depth"],
        ["Exposure C (open)", "+6\" post depth, steel insert req."],
        ["Exposure D (coastal)", "Engineering required >4' height"],
      ]},
    ],
    note: "Vinyl-Specific: All vinyl fence systems must meet ASTM F964. Steel or aluminum post inserts are mandatory in wind zones C/D. Manufacturer installation specs often exceed code minimums.",
  },
  {
    id: "chainlink", name: "Chain Link Fences", sub: "Residential & Commercial — ASTM F567, F668, F1043",
    glyph: "chain", badges: ["IRC", "IBC"], color: "#9aa6b8",
    mini: [["Height", "4–6 ft"], ["Fabric", "9–11.5 ga"], ["Post", "Sch 40"], ["Spacing", "10 ft max"]],
    sections: [
      { title: "Height Requirements", tag: "IRC/IBC", rows: [
        ["Residential (no permit)", "4–6' (varies by jurisdiction)"],
        ["Commercial", "6–12' per IBC Chapter 3"],
        ["Security Topping", "Barbed wire: commercial/industrial only"],
        ["Front Yard", "3–4' typical max"],
      ]},
      { title: "Fabric Standards", tag: "ASTM F668", rows: [
        ["Residential Gauge", "11.5 ga (2.4mm) min"],
        ["Commercial Gauge", "9 ga (3.8mm)"],
        ["Mesh Opening", "2\" × 2\" standard (2-¼\" residential)"],
        ["Coating", "Class 1 zinc (galvanized) per ASTM A392"],
        ["Vinyl Coated", "ASTM F668 Class 2b (PVC over galv.)"],
        ["Height vs Gauge", "≥8': 9 ga; ≤6': 11 ga acceptable"],
      ]},
      { title: "Framework", tag: "ASTM F1043", rows: [
        ["Terminal Post", "2-½\" O.D. Sch 40 (≤6' fence)"],
        ["Line Post", "1-⅝\" O.D. min (residential)"],
        ["Commercial Line Post", "2-½\" O.D. Sch 40"],
        ["Top Rail", "1-⅝\" O.D. (residential)"],
        ["Post Spacing", "10' max (residential), 8' (commercial)"],
        ["Embedment", "⅓ total post length, min 18\""],
      ]},
      { title: "Tension & Hardware", tag: "ASTM F567", rows: [
        ["Tension Bands", "1 per foot of fence height (terminal posts)"],
        ["Tension Bar", "1 per terminal post"],
        ["Tie Wires", "Every 12–15\" on line posts/top rail"],
        ["Post Caps", "Required on all posts (loop or dome)"],
      ]},
    ],
    note: "Chain Link Specific: ASTM F567 covers the complete installation standard. Commercial installs (>6') require IBC compliance and often engineering. Privacy slats add wind load but don't change structural requirements.",
  },
  {
    id: "ornamental", name: "Ornamental Iron & Aluminum", sub: "Wrought Iron, Aluminum Picket — ASTM F2408, B221",
    glyph: "iron", badges: ["IRC", "POOL CODE"], color: "#2b3340",
    mini: [["Height", "4–6 ft"], ["Picket Spacing", "≤4\""], ["Bottom Gap", "≤4\""], ["Pool", "≤1¾\""]],
    sections: [
      { title: "Height Requirements", tag: "IRC R301", rows: [
        ["Residential Fence", "4–6' (varies by jurisdiction)"],
        ["Pool Barrier (IRC)", "48\" minimum (measured outside)"],
        ["Pool Barrier (ISPSC)", "48\" minimum — no exceptions"],
        ["Commercial", "Per IBC and local ordinance"],
      ]},
      { title: "Picket / Baluster Spacing", tag: "IRC R312.1", rows: [
        ["General Fence", "≤4\" between pickets (no 4\" sphere pass)"],
        ["Pool Barrier (Vert Spacing)", "≤1-¾\" where horizontal rails <45\" apart (ISPSC 305.2.1.1)"],
        ["Bottom Clearance", "≤4\" from grade (general); ≤2\" (pool)"],
        ["Decorative Openings", "Must not allow 4\" sphere passage"],
      ]},
      { title: "Pool Barrier Requirements", tag: "IRC R327 / ISPSC", rows: [
        ["Min Height", "48\" above grade (outside measurement)"],
        ["Max Opening", "≤1-¾\" (pickets), 4\" sphere test"],
        ["Non-Climbable", "No horizontal members within 45° of grade"],
        ["Gate Self-Close", "Required — opens outward from pool"],
        ["Gate Self-Latch", "Min 54\" from grade (or key/combo lock)"],
        ["Adjacent Structures", "No climbable objects within 36\" horizontal"],
      ]},
      { title: "Material Standards", tag: "ASTM F2408", rows: [
        ["Aluminum", "ASTM B221 (6063-T5 or T6 alloy)"],
        ["Steel/Iron", "ASTM A653 (galvanized) or A500"],
        ["Powder Coat", "AAMA 2604 (high-performance) min"],
        ["Picket Min Wall", "0.062\" (aluminum); ⅛\" sq solid (iron)"],
        ["Post Min Wall", "0.125\" aluminum; 2\" sq steel post"],
      ]},
    ],
    note: "Critical — Pool Code: Pool barriers have the strictest fence code requirements. IRC R327 / ISPSC (2021+) require 48\" height, ≤1-¾\" openings, self-closing/self-latching gates, and non-climbable design. Violations can result in stop-work orders and liability.",
  },
  {
    id: "railings", name: "Deck & Porch Railings", sub: "Guards & Handrails — IRC R312, R317, R507",
    glyph: "rail", badges: ["IRC", "IBC"], color: "#caa46e",
    mini: [["Guard", "36\" res / 42\" comm"], ["Baluster", "≤4\" (sphere)"], ["Load", "200 lb conc."], ["Graspable", "1¼–2\" circ."]],
    sections: [
      { title: "Guard Height Requirements", tag: "IRC R312.1.1", rows: [
        ["When Required", "Walking surfaces >30\" above grade"],
        ["Min Height (IRC)", "36\" from deck surface"],
        ["Min Height (IBC)", "42\" (commercial/multi-family)"],
        ["Measurement Point", "Top of guard to deck surface"],
        ["Open Sides of Stairs", "34\" min measured vertically from stair nosing"],
      ]},
      { title: "Baluster & Opening Limits", tag: "IRC R312.1.3", rows: [
        ["Max Opening", "4\" (no 4\" sphere shall pass)"],
        ["Triangular Openings", "4\" sphere test at all points"],
        ["Bottom Rail to Deck", "≤4\" gap"],
        ["Horizontal Rails", "Discouraged — climbable by children"],
        ["Cable Rail Spacing", "≤4\" deflection under 200 lb point load"],
      ]},
      { title: "Structural Load Requirements", tag: "IRC R301.5", rows: [
        ["Top Rail — Concentrated", "200 lb at any point, any direction"],
        ["Top Rail — Distributed", "50 plf (pounds per linear foot)"],
        ["Infill — Concentrated", "50 lb on 1 sq ft area"],
        ["Post-to-Deck Connection", "Must resist 200 lb without failure"],
        ["Post Attachment", "Bolted through rim joist (not lag screws alone)"],
      ]},
      { title: "Handrail Requirements (Graspable)", tag: "IRC R311.7.8", rows: [
        ["When Required", "Stairs with ≥4 risers (IRC); ≥1 riser (IBC)"],
        ["Graspable Diameter", "1-¼\" to 2\" circular cross-section"],
        ["Non-Circular (Type II)", "Perimeter 4\"–6¼\"; max cross-section ≤2-¼\""],
        ["Height", "34–38\" from stair nosing (measured vertically)"],
        ["Continuity", "Full length of stairs, no interruptions"],
      ]},
    ],
    note: "Guards prevent falls; handrails provide grip. Both are commonly cited in inspections. Post-to-rim connection failures are the #1 deck collapse cause — through-bolt, never lag-only.",
  },
  {
    id: "stairs", name: "Staircases & Spiral Stairs", sub: "Interior & Exterior — IRC R311.7, IBC 1011",
    glyph: "stairs", badges: ["IRC", "IBC"], color: "#caa46e",
    mini: [["Riser", "≤7¾\""], ["Tread", "≥10\""], ["Width", "≥36\""], ["Headroom", "6'-8\""]],
    sections: [
      { title: "Stair Dimensions", tag: "IRC R311.7", rows: [
        ["Min Width", "36\" clear (above handrail)"],
        ["Max Riser Height", "7-¾\""],
        ["Min Tread Depth", "10\" (nose to nose)"],
        ["Riser Uniformity", "≤⅜\" between largest and smallest in the flight"],
        ["Tread Uniformity", "≤⅜\" between largest and smallest in the flight"],
        ["Nosing Projection", "¾\" to 1-¼\" (if solid risers)"],
        ["Open Risers", "OK if opening ≤4\" (sphere test)"],
        ["Min Headroom", "6'-8\" (80\") measured vertically"],
      ]},
      { title: "Spiral Stair Requirements", tag: "IRC R311.7.10.1", rows: [
        ["Min Width", "26\" clear"],
        ["Min Tread at Walkline (12\" from narrow edge)", "6-¾\""],
        ["Max Riser Height", "9-½\""],
        ["Min Headroom", "6'-6\" (78\")"],
        ["Center Column", "Required structural support"],
        ["Usage Limit", "1 room served (IRC) — not primary stair"],
      ]},
      { title: "Handrail Requirements", tag: "IRC R311.7.8", rows: [
        ["When Required", "≥4 risers (IRC); ≥1 riser (IBC)"],
        ["Height", "34–38\" from stair nosing"],
        ["Graspable Diameter", "1-¼\" to 2\" (circular)"],
        ["Both Sides", "Required if stair width ≥44\""],
        ["Extensions (IBC/ADA only)", "12\" + 1 tread depth — not required by residential IRC"],
        ["Continuity", "Continuous full length, no interruptions"],
      ]},
      { title: "Structural Requirements", tag: "IRC R301.5", rows: [
        ["Stair Live Load", "40 psf or 300 lb concentrated"],
        ["Stringer Sizing", "2×12 min for >36\" width"],
        ["Connection", "Joist hangers or ledger-bolted, not nails"],
        ["Exterior Stairs", "Footings below frost line per R403"],
        ["Spiral Center Column", "Engineered connection top and bottom"],
      ]},
      { title: "IBC Commercial Differences", tag: "IBC 1011", rows: [
        ["Min Width", "44\" (occupant load ≤50); 36\" (dwelling)"],
        ["Max Riser", "7\" (vs IRC 7-¾\")"],
        ["Min Tread", "11\" (vs IRC 10\")"],
        ["Handrail Required", "≥1 riser (vs IRC ≥4 risers)"],
        ["Guard Height", "42\" (vs IRC 36\"/34\")"],
        ["Spiral Stairs", "Not permitted as required means of egress"],
      ]},
    ],
    note: "Critical Uniformity Rule: The ⅜\" max variation between risers/treads is the #1 staircase inspection violation. Measure every riser and tread — a single ⅜\"+ deviation fails the entire staircase. For spirals, the tread measurement is taken at the walkline (12\" from the narrow edge), not the center.",
  },
];
